export default __webpack_public_path__ + "static/media/product_img1.ce564aa4.png";